<template>
  <header id="mobile-header" class="mobile-show-content fixed w-full bg-white shadow shadow-md py-10">
    <nav class="px-12 relative">
      <div class="flex justify-between items-center">
        <div class="flex items-center">
          <div>
            <the-nav-bar-button></the-nav-bar-button>
          </div>
          <a href="/" class="block">
            <img
              src="/assets/images/logo.png"
              alt="drybrush Gallery - Filipino Art"
              class="w-120 lg:w-140 object-fit"
            />
          </a>
        </div>
        <div class="col-span-3 md:gap-20 lg:gap-0 flex items-center">
          <slot name="icons"></slot>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
import TheNavbarSearchResult from "../../Modules/Search/TheNavbarSearchResult.vue";
import TheNavBarMobileItem from "./TheNavBarMobileItem.vue";
import TheNavBarButton from "./TheNavBarButton.vue";
import SearchForm from "../../Universal/SearchForm.vue";

export default {
  components: {
    TheNavbarSearchResult,
    TheNavBarMobileItem,
    TheNavBarButton,
    SearchForm,
  },

  props: {
    menu: Object,
  },

  computed: {
    defaultSearchValue() {
      return new URLSearchParams(window.location.search).get("search") ?? null;
    },
  },
};
</script>
